module.exports = __webpack_public_path__ + "static/media/cxsp.c3e605b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cxsp.mp4
// module id = ICu5
// module chunks = 20